<template>
  <div
    class="modal"
    :style="{ transform: showModal ? 'scale(1)' : 'scale(0)' }"
  >
    <div
      class="modal-box"
      :style="{ bottom: showModal ? 0 : '-100px', ...boxStyle }"
      @click.stop
    >
      <img
        class="close-btn"
        src="@/assets/img/creator/icon-close-grey.png"
        @click="onClose"
        v-if="greyIcon"
      />
      <img
        class="close-btn"
        src="@/assets/img/creator/icon-close.png"
        @click="onClose"
        v-else
      />
      <div class="modal-body" ref="modalBody">
        <slot></slot>
      </div>
    </div>
    <div class="bottom-mask" v-if="showBottomMask"></div>
  </div>
</template>
<script>
export default {
  name: 'pmodal',
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
    boxStyle: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
    showBottomMask: {
      type: Boolean,
      required: false,
      default: () => {
        return true
      },
    },
    greyIcon: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      },
    },
  },
  watch: {
    showModal(val) {
      this.$refs.modalBody.scrollTop = 0
    },
  },
}
</script>

<style lang="less" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.7);
  .bottom-mask {
    content: '';
    position: absolute;
    width: 100%;
    height: 0.96rem;
    left: 0px;
    bottom: 0;
    background: linear-gradient(180deg, rgba(34, 34, 34, 0) 0%, #222222 100%);
  }
  .modal-box {
    width: 100%;
    border-radius: 0.24rem 0.24rem 0 0;
    background-color: rgba(34, 34, 34, 1);
    position: relative;
    padding: 0.7rem 0.32rem 0 0.32rem;
    transition: bottom 500ms;
  }
  .modal-body {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 8.94rem;
    overflow: scroll;
  }
  .modal-body::-webkit-scrollbar {
    width: 0 !important;
    display: none;
  }
  .close-btn {
    position: absolute;
    top: 0.32rem;
    right: 0.32rem;
    width: 0.4rem;
    height: 0.4rem;
  }
}
</style>
